import { yupResolver } from "@hookform/resolvers";
import React, { useContext, useEffect, useState } from "react";
import { Col, Row, Button, Form, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { WidgetContext } from "../../../../../context/WidgetContext";
import { FindReservationFormData, FindReservationSchema, FindReservationSchemaDefaultValues } from "./schemas/FindReservationSchema";

interface props {
  show: boolean;
  onHide: () => void;
  handleSearchRequest: (email: string, itineraryNumber: string) => void;
}

const FindReservation: React.FC<props> = (props) => {
  const { startWidget, style, viewPortBreakPoint } = useContext(WidgetContext);
  const { show, onHide, handleSearchRequest } = props;

  const { register, handleSubmit, errors, formState, setValue, reset, getValues } = useForm<FindReservationFormData>({
    mode: "onSubmit",
    resolver: yupResolver(FindReservationSchema),
    defaultValues: FindReservationSchemaDefaultValues
  });

  const submit = (formData: FindReservationFormData) => {
    handleSearchRequest(formData.email, formData.itineraryNumber);
  }

  return (
    <React.Fragment>
      <Modal
        size="lg"
        show={show}
        onHide={onHide}
        backdropClassName="white-overlay"
        dialogClassName="box-shadow mobile-full-width"
      >
        <Modal.Header translate="" closeButton closeLabel="close window">
          <div className="w-100">
            <Modal.Title style={{ color: style.fontColor }}>Find Reservation</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Form className="w-100 widget-text" noValidate onSubmit={handleSubmit(submit)}>
            <Row className="w-100">
              <p
                style={{
                  color: style.fontColor,
                  fontWeight: "bold",
                  fontSize: "14px",
                  textAlign: "center",
                  marginLeft: "15px",
                  marginRight: "15px",
                }}
              >
                Please Enter the Itinerary Number or Email Address below to find a previously saved
                Quote or Itinerary
              </p>
            </Row>
            <Form.Row>
              <Col>
                {/* <Form.Label style={{ color: style.fontColor }}>Itinerary #</Form.Label> */}
                <Form.Control
                  style={{ color: style.fontColor }}
                  placeholder="Itinerary#"
                  className="box-shadow"
                  name="itineraryNumber"
                  ref={register}
                  isValid={formState.isSubmitted && !errors.itineraryNumber}
                  isInvalid={formState.isSubmitted && (!!errors.itineraryNumber)}
                />

                <Form.Control.Feedback type="invalid">
                  {errors.itineraryNumber && errors.itineraryNumber.message}
                </Form.Control.Feedback>
              </Col>
              <Col>
                {/* <Form.Label style={{ color: style.fontColor }}>Email Address</Form.Label> */}
                <Form.Control
                  style={{ color: style.fontColor }}
                  placeholder="Email Address"
                  className="box-shadow"
                  name="email"
                  ref={register}
                  isValid={formState.isSubmitted && !errors.email}
                  isInvalid={formState.isSubmitted && (!!errors.email)}
                />

                <Form.Control.Feedback type="invalid">
                  {errors.email && errors.email.message}
                </Form.Control.Feedback>
              </Col>
            </Form.Row>
            <Row
              style={{ marginTop: "40px" }}
            >
              <Button
                style={{ backgroundColor: style.buttonColor }}
                className="widget-font"
                type="submit"
              >
                Find Itinerary
              </Button>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}

export default FindReservation;
